import { render, staticRenderFns } from "./search-box-date.vue?vue&type=template&id=0cbddac1&"
import script from "./search-box-date.vue?vue&type=script&lang=js&"
export * from "./search-box-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports